import lod_ from "lodash";
import { Divider } from "@mui/material";
import MDBox from "components/Basics/MDBox";
import MDTypography from "components/Basics/MDTypography";
import { LittleForm } from "components/Custom/LittleForm";
import { queryDictionary } from "helpers/dictionary";
import { createDictionarySkeleton } from "helpers/form";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

/**
 * Theme configuration form, used in theme edition dialog. It will generate a form based on the themeConfigDictionary and the values of the asset
 * @returns {*} JSX Element
 */
const ThemeConfigForm = ({ asset = {}, handleChange = () => {} }) => {
	const dispatch = useDispatch();

	const [dictionary, setDictionary] = useState({});
	const [skeleton, setSkeleton] = useState({});

	const getDictionary = async code => {
		const dictionaryResult = await queryDictionary(dispatch, code);
		const buildedSkeleton = createDictionarySkeleton(
			dictionaryResult,
			asset.values?.faqConfig || {}
		);

		console.log("dictionaryResult", dictionaryResult, buildedSkeleton);

		setDictionary(dictionaryResult);
		setSkeleton(buildedSkeleton);
	};

	useEffect(() => {
		getDictionary("themeConfigDictionary");
	}, []);

	useEffect(() => {
		if (lod_.isEmpty(dictionary)) return;
		const buildedSkeleton = createDictionarySkeleton(dictionary, asset.values?.faqConfig || {});
		setSkeleton(buildedSkeleton);
	}, [asset, dictionary]);

	return (
		<MDBox>
			<Divider />
			<MDTypography variant="h6" fontWeight="medium" mt={2} mb={1}>
				Theme Configuration
			</MDTypography>
			<LittleForm
				object={dictionary?.items}
				metadatasSkeleton={skeleton}
				handleChange={handleChange}
			/>
		</MDBox>
	);
};

export default ThemeConfigForm;
